export class Param {
    code: string;
    value: string;
    constructor() {
        this.code = "";
        this.value = "";
    }
}